const questionTypes: any = {
  text: {
    id: 0,
    name: `Texto`,
    type: 'text',
  },
  number: {
    id: 0,
    name: `Número`,
    type: 'number',
  },
  date: {
    id: 0,
    name: `Fecha/Hora`,
    type: 'date',
    dateMode: 'date',
    dateFormat: 'DD-MM-YYYY',
  },
  signature: {
    id: 0,
    name: `Firma`,
    type: 'signature',
  },
  barcode: {
    id: 0,
    name: `Código`,
    type: 'barcode',
  },
  photo: {
    id: 0,
    name: `Foto`,
    type: 'photo',
  },
  multi_photo: {
    id: 0,
    name: `Multifoto`,
    type: 'multi_photo',
  },
  multi_option: {
    id: 0,
    name: `Selección Múltiple`,
    type: 'multi_option',
    options: ['Alternativa 1', 'Alternativa 2', 'Alternativa 3'],
  },
  select_option_metadata: {
    id: 0,
    name: `Seleccionar Alternativas Datos`,
    type: 'select_option_metadata',
    options: ['Alternativa 1', 'Alternativa 2', 'Alternativa 3'],
    listChoices: [],
  },
  select_option_metadata_comments: {
    id: 0,
    name: `Seleccionar Alternativas Datos`,
    type: 'select_option_metadata',
    options: ['Alternativa 1', 'Alternativa 2', 'Alternativa 3'],
    listChoices: [],
  },
  select_check_metadata: {
    id: 0,
    name: `Check Lista Datos`,
    type: 'select_check_metadata',
    listChoices: [],
  },
  select_number_metadata: {
    id: 0,
    name: `Número Lista Datos`,
    type: 'select_number_metadata',
    listChoices: [],
  },
  select_text_metadata: {
    id: 0,
    name: `Texto Lista Datos`,
    type: 'select_text_metadata',
    listChoices: [],
  },
  static_text: {
    id: 0,
    name: `Texto Fijo`,
    type: 'static_text',
  },
  select_metadata: {
    id: 0,
    name: `Selección Lista Datos`,
    type: 'select_metadata',
    listChoices: [],
  },
  table: {
    id: 0,
    name: 'Preguntas Repetibles',
    type: 'table',
  },
  attachment: {
    id: 0,
    name: 'Archivo Adjunto',
    type: 'attachment',
    formats: ['any'],
    quantity: 1,
  },
  select_activity_period_time: {
    id: 0,
    name: 'Actividad Lista Datos',
    type: 'select_activity_period_time',
    listChoices: [],
    startTime: '08:00',
    workingTime: '720',
    intervalDefault: '30',
  },
};

const questionTypesList: string[] = [
  'text',
  'number',
  'date',
  'signature',
  'barcode',
  'photo',
  'multi_photo',
  'multi_option',
  'select_option_metadata',
  'select_option_metadata_comments',
  'select_check_metadata',
  'select_number_metadata',
  'select_text_metadata',
  'static_text',
  'select_metadata',
  'attachment',
  'select_activity_period_time',
  'table',
];

export { questionTypes, questionTypesList };
